import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 * Container component used to wrap sections for assigned or available items.
 * Displays a title, optional counter, icon, and renders child content.
 *
 * @param {Object} props - Component properties
 * @param {string} props.title - Translation key for the container title
 * @param {React.ReactNode} props.children - Content to be rendered inside the container
 * @param {number|null} [props.count=null] - Optional count to display (e.g., number of items)
 * @param {React.ReactNode} props.icon - Icon displayed next to the title
 * @param {string} [props.containerClass] - अतिरिक्त CSS classes for container styling
 * @param {string} [props.borderClass='border-full-shades-200'] - Border CSS class; swap to an error border to flag an empty required section
 *
 * @returns {JSX.Element} Styled container component
 */
const AddAssignedItemsContainer = (
    {
        title ,
        children,
        count=null,
        icon,
        containerClass,
        borderClass='border-full-shades-200'
    }
) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={`${containerClass} ${borderClass} card-border-8px`}>

                <div className='d-flex align-items-center p-16px'>
                    <div>{icon}</div>
                    <p className="fs-16px ibl-font-w-600 font-color-general-950 mx-2">{t(title)}</p>

                    { count !== null &&
                        <div className={`d-flex justify-content-center align-items-center border-radius-8px  minw-20px background-shades-200 px-1`}>
                            <p className={`fs-14px ibl-font-w-500 font-color-shades-500 px-1`}>{count}</p>
                        </div>
                    }
                </div>

                <div className="border-bottom-shades-300" />
                {
                    children
                }
            </div>
        </>
    );

}

export default AddAssignedItemsContainer
